export default {
    TWITTER: 'TWITTER',
    FACEBOOK: 'FACEBOOK',
    INSTAGRAM: 'INSTAGRAM',
    ITUNES: 'ITUNES'
};
